import { Wallet } from "./wallet";
import { 
    PublicKey,
    Transaction,
    SystemProgram,
    LAMPORTS_PER_SOL
} from "@solana/web3.js"
import * as bs58 from "bs58" ;


export class SolflareWallet extends Wallet {

    constructor(){
        super();
        this.icon = 'https://lh3.googleusercontent.com/uKZnhWrko3Chg3GkcqPZdj7RqfY0_toJ6s7JLWVMvBFb63pICmRYRsURzknIyuN0MeVlBSdTzNMm72zx0nh7-gJp1w=w128-h128-e365-rj-sc0x00ffffff';
        this.name = "Solflare" ;
        //@ts-ignore
        if ( window.solflare &&window.solflare?.isSolflare ){
            this.installed = true ;
            localStorage.setItem('solflare', "installed");
        }else if ( localStorage.getItem('solflare') ){
            this.installed = true ;
        }
    }
    async disconnect(){
        //@ts-ignore
        await window.solflare.request({ method: "disconnect" });
        return true ;
    }

    static async create(){

        const solflareWallet = new SolflareWallet();
        //@ts-ignore
        if ( window.solflare ){
            
            solflareWallet.installed = true ;
            localStorage.setItem('solflare', "installed");



        }else if ( localStorage.getItem('solflare') ){
            solflareWallet.installed = true ;
        }
        return solflareWallet ;

    }
    private stakeConnection(){
        //@ts-ignore
        Wallet.provider = window.solflare ;
        //@ts-ignore
        this.publicKey = new PublicKey(Wallet.provider.publicKey) ;
        this.connected = true ;
    } 

    async connect() : Promise<Wallet> {
        await super.connect();
        
        try{
            //@ts-ignore
            await window.solflare.connect({ onlyIfTrusted : true });
            this.stakeConnection();
        }catch(e){

        }

        //@ts-ignore
        if ( Wallet.provider !== null || Wallet.provider !== window.solflare ){
            //@ts-ignore
            Wallet.provider = window.solflare ;
            //@ts-ignore
            await window.solflare.connect();
            //@ts-ignore
            if ( window.solflare.publicKey ){
                //@ts-ignore
                Wallet.provider = window.solflare ;
                //@ts-ignore
                this.publicKey = new PublicKey(Wallet.provider.publicKey) ;
            }
        }
        return this ;
    }
    


    async signTransfer(destinationPubkey: string, sol: number): Promise<Transaction> {
        const payerPubKey = this.publicKey ;
        const destinationPubKey = new PublicKey(destinationPubkey) ;
        const transaction = new Transaction();
        transaction.add( SystemProgram.transfer({
          fromPubkey : payerPubKey!,
          toPubkey : destinationPubKey,
          lamports : sol*LAMPORTS_PER_SOL
        }));
        const blockhash = await Wallet.solanaConnection?.getRecentBlockhash();
        transaction.recentBlockhash = blockhash!.blockhash ;
        transaction.feePayer = payerPubKey! ;
        //@ts-ignore
        const nt = await Wallet.provider.signTransaction(transaction) ;
        return nt ;
    }

    /**
     * depreciated
     * @param destinationPublickKey 
     * @param sol 
     * @returns 
     */
    async sendTransaction( destinationPublickKey : string, sol : number ){

        const payerPubKey = this.publicKey ;
        const destinationPubKey = new PublicKey(destinationPublickKey) ;
    
        // const senderAccountInfo = await Wallet.solanaConnection?.getAccountInfo(payerPubKey!);
        // const receiverAccountInfo = await Wallet.solanaConnection?.getAccountInfo(destinationPubKey);
    
        const transaction = new Transaction();
        transaction.add( SystemProgram.transfer({
          fromPubkey : payerPubKey!,
          toPubkey : destinationPubKey,
          lamports : sol*LAMPORTS_PER_SOL
        }));
    
        const blockhash = await Wallet.solanaConnection?.getRecentBlockhash();
        transaction.recentBlockhash = blockhash!.blockhash ;
        transaction.feePayer = payerPubKey! ;
    
        //@ts-ignore
        const transactionSigned = await Wallet.provider.signTransaction(transaction) ;
        let signature = await Wallet.solanaConnection?.sendRawTransaction(transactionSigned.serialize());
        let result = await Wallet.solanaConnection?.confirmTransaction(signature!, "singleGossip" )! ;
        return signature ;

    }
    async signMessage(message : string ){
        const encodedMessage = new TextEncoder().encode(message);
        //@ts-ignore
        const signedMessage = await Wallet.provider.signMessage(encodedMessage, "utf8");
        const signature = bs58.encode(signedMessage.signature) ;
        return signature ;
    }


}